import { useEffect, useState, useRef } from 'react';
import { api } from '../../utils/api';
import { useAuth } from '../../context/AuthContext';

export default function MentorMateriais() {
  const { token } = useAuth();
  const [materiais, setMateriais] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [nome, setNome] = useState('');
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');
  const fileRef = useRef(null);

  const load = () => api.get('/materiais', token).then(setMateriais);
  useEffect(() => { load(); }, [token]);

  const upload = async (e) => {
    e.preventDefault();
    const file = fileRef.current?.files[0];
    if (!file) return setErro('Selecione um arquivo');

    setUploading(true); setErro(''); setSucesso('');
    const form = new FormData();
    form.append('arquivo', file);
    form.append('nome', nome || file.name);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL || '/api'}/materiais/upload`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: form,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setSucesso(data.mensagem);
      setNome('');
      fileRef.current.value = '';
      await load();
    } catch (err) {
      setErro(err.message);
    } finally {
      setUploading(false);
    }
  };

  const remover = async (id, nome) => {
    if (!window.confirm(`Remover "${nome}"?`)) return;
    await api.del(`/materiais/${id}`, token);
    setMateriais(prev => prev.filter(m => m.id !== id));
  };

  const formatSize = (bytes) => {
    if (!bytes) return '-';
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024*1024) return (bytes/1024).toFixed(1) + ' KB';
    return (bytes/1024/1024).toFixed(1) + ' MB';
  };

  const tipoIcon = (tipo) => ({ pdf: '📄', docx: '📝', txt: '📋' }[tipo] || '📁');

  return (
    <div style={{padding:'28px 32px',maxWidth:700}}>
      <div style={{marginBottom:24}}>
        <div style={{fontSize:22,fontWeight:700,letterSpacing:'-.02em'}}>Biblioteca da IA</div>
        <div style={{fontSize:13,color:'#6B7289',marginTop:3}}>Materiais que treinam a IA com seu método</div>
      </div>

      {/* Upload */}
      <div className="card" style={{marginBottom:20,borderLeft:'3px solid #1A2ECC'}}>
        <div style={{fontSize:13,fontWeight:600,marginBottom:14}}>📤 Subir novo material</div>
        <form onSubmit={upload}>
          <div style={{marginBottom:12}}>
            <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:5}}>Nome do material (opcional)</label>
            <input className="input-field" placeholder="Ex: Módulo 1 — Validação de Produto" value={nome} onChange={e=>setNome(e.target.value)} />
          </div>
          <div style={{marginBottom:14}}>
            <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:5}}>Arquivo (PDF, DOCX ou TXT — máx 20MB)</label>
            <input ref={fileRef} type="file" accept=".pdf,.docx,.txt"
              style={{width:'100%',padding:'10px',border:'0.5px solid #E4E6EF',borderRadius:8,fontSize:13,background:'#fafbfe',cursor:'pointer'}} />
          </div>
          {erro && <div style={{background:'#FDEAEA',borderRadius:8,padding:'9px 14px',fontSize:12,color:'#922020',marginBottom:12}}>{erro}</div>}
          {sucesso && <div style={{background:'#E6F7F1',borderRadius:8,padding:'9px 14px',fontSize:12,color:'#0A6B47',marginBottom:12}}>✅ {sucesso}</div>}
          <button className="btn-primary" type="submit" disabled={uploading} style={{width:'100%',padding:12}}>
            {uploading ? 'Processando e indexando...' : 'Subir e indexar para a IA →'}
          </button>
        </form>
      </div>

      {/* Como funciona */}
      <div className="card" style={{marginBottom:20,background:'#F7F8FC',border:'none'}}>
        <div style={{fontSize:12,fontWeight:600,marginBottom:8}}>Como funciona</div>
        <div style={{fontSize:12,color:'#6B7289',lineHeight:1.7}}>
          Você sobe PDFs, Word ou TXT do seu método. O sistema extrai o texto e a IA passa a responder dúvidas dos alunos baseada nesses materiais — usando sua linguagem, seus exemplos, seus cálculos. Não é o ChatGPT genérico, é você disponível 24h.
        </div>
      </div>

      {/* Lista de materiais */}
      <div className="card" style={{padding:0,overflow:'hidden'}}>
        <div style={{padding:'12px 18px',borderBottom:'0.5px solid #E4E6EF',fontSize:12,fontWeight:600,color:'#6B7289',textTransform:'uppercase',letterSpacing:'.06em'}}>
          {materiais.length} material{materiais.length!==1?'is':''} indexado{materiais.length!==1?'s':''}
        </div>
        {materiais.length===0 && (
          <div style={{padding:32,textAlign:'center',color:'#6B7289',fontSize:13}}>
            Nenhum material ainda. Suba seu primeiro PDF acima.
          </div>
        )}
        {materiais.map(m => (
          <div key={m.id} style={{display:'flex',alignItems:'center',gap:14,padding:'14px 18px',borderBottom:'0.5px solid #E4E6EF'}}>
            <span style={{fontSize:24,flexShrink:0}}>{tipoIcon(m.tipo)}</span>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:13,fontWeight:500,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{m.nome}</div>
              <div style={{fontSize:11,color:'#6B7289',marginTop:2}}>
                {m.tipo.toUpperCase()} · {formatSize(m.tamanho)} · {new Date(m.criado_em).toLocaleDateString('pt-BR')}
              </div>
            </div>
            <span className="badge badge-green" style={{flexShrink:0}}>Indexado</span>
            <button onClick={()=>remover(m.id, m.nome)}
              style={{fontSize:11,color:'#D63B3B',background:'#FDEAEA',border:'none',borderRadius:6,padding:'5px 10px',cursor:'pointer',flexShrink:0}}>
              Remover
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
